import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { CreateItemconfigurationDto } from './dto/create-itemconfiguration.dto';
import { UpdateItemconfigurationDto } from './dto/update-itemconfiguration.dto';
import { Itemconfiguration } from './entities/itemconfiguration.entity';
import * as fs from 'fs'
import { ItemConfigurationRepo } from './repositories/itemconfiguration.repo';

@Injectable()
export class ItemconfigurationService {
  constructor(
    @InjectRepository(Itemconfiguration) private userRepository: Repository<Itemconfiguration>,
  ) { }
  create(createItemconfigurationDto: CreateItemconfigurationDto) {
    const fileDestination = 'packages/services/files';
    if (!fs.existsSync(fileDestination)) {
      fs.mkdirSync(fileDestination)
    }
    const fileName = `${createItemconfigurationDto.uid}.${createItemconfigurationDto.originalname.substring(createItemconfigurationDto.originalname.lastIndexOf('.') + 1)}`;
    console.log(fileName);
    const filePath = `${fileDestination}/${fileName}`;
    let base64Data = createItemconfigurationDto.image.replace(/^data:image\/png;base64,/, "");
    base64Data += base64Data.replace('+', ' ');
    const binaryData = Buffer.from(base64Data, 'base64');
    fs.writeFileSync(filePath, binaryData);
    const createItemconfigurationDtoN: Itemconfiguration = JSON.parse(JSON.stringify({ ...createItemconfigurationDto }));
    createItemconfigurationDtoN.imagename = fileName;
    createItemconfigurationDtoN.path = filePath;
    createItemconfigurationDtoN.image = binaryData;
    return this.userRepository.save(createItemconfigurationDtoN);
  }

  async findAll(): Promise<Itemconfiguration[]> {
    const db = this.userRepository;
    const user = await db.find({ select: ['id', 'imagename', 'item', 'path', 'originalname', 'image'] });
    return user;
  }

  // findOne(id: number) {
  //   return this.userRepository.findOne({ where: { id } });
  // }

  // update(id: number, updateItemconfigurationDto: UpdateItemconfigurationDto) {
  //   const updateItemconfigurationDtoN: any = { ...updateItemconfigurationDto }
  //   return this.userRepository.update(id, updateItemconfigurationDtoN);
  // }

  // remove(id: number) {
  //   return this.userRepository.delete(id);
  // }
}
